import { FC } from 'react';
import { Box, Button, Modal, Typography, Backdrop, Fade } from '@mui/material';
import { EnvelopeSimple } from '@phosphor-icons/react';
import { routes } from '../../constants/routes';
import { useNavigate } from 'react-router';

interface EmailVerificationModalProps {
  open: boolean;
  onClose: () => void;
}

const EmailVerificationModal: FC<EmailVerificationModalProps> = ({
  open,
  onClose,
}) => {
  const navigate = useNavigate();
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          backdropFilter: 'blur(4px)',
        },
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '543px',
            height: '300px',
            bgcolor: 'background.paper',
            borderRadius: '8px',
            boxShadow: 24,
            p: 4,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 64,
                height: 64,
                borderRadius: '50%',
                backgroundColor: 'rgba(235, 238, 255, 1)',
              }}
            >
              <EnvelopeSimple size={32} weight="duotone" color="#4361ee" />
            </Box>
            <Box
              sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 1 }}
            >
              <Typography
                sx={{
                  fontSize: '24px',
                  fontWeight: 500,
                  color: 'text.primary',
                }}
              >
                Verify your email address
              </Typography>
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: 400,
                  color: 'text.secondary',
                }}
              >
                A verification link has been sent to your provided email
                address. Please check your email and click the link provided in
                the email to complete your account registration
              </Typography>
            </Box>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(routes.login)}
              sx={{
                width: '100%',
                textTransform: 'none',
                boxShadow: 'none',
                fontSize: '16px',
                fontWeight: 600,
                color: 'white',
                borderRadius: '8px',
                height: '34px',
              }}
            >
              Go to Login
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default EmailVerificationModal;
